import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";
import { sendNotifInfo } from "./Api/ClientServices";

const firebaseConfig = {
  apiKey: "AIzaSyAI-6ra1K4W2O03bB_gFWqRZGmXVumc3Vw",
  authDomain: "barest-a5cb9.firebaseapp.com",
  projectId: "barest-a5cb9",
  storageBucket: "barest-a5cb9.appspot.com",
  messagingSenderId: "816973146919",
  appId: "1:816973146919:web:0d70f6fb9a55e398b29702",
  measurementId: "G-HCL7BJVG30"
};

const app = initializeApp(firebaseConfig);

let messaging = null;

isSupported().then((supported) => {
  if (supported) {
    messaging = getMessaging(app);
  }
});

export const getTokens = async (setTokenFound) => {
  if (!messaging) return;
  try {
    const currentToken = await getToken(messaging, {
      vapidKey: "BGxqtLZw2k4ipNB4-iSEGMWUO2tlCbTwlocGySqov__Gg73unFi8NmFXCq6F_1qLwleac4nH9v0hN4SMTVxrMqM"
    });
    if (currentToken) {
      if (localStorage.getItem("TokenNotifation") !== currentToken) {
        let info = { token: currentToken, type: "user" };
        sendNotifInfo(info, (succ) => {
          if (succ.status === 1) {
            localStorage.setItem("TokenNotifation", currentToken);
            setTokenFound(true);
          }
        });
      }
    } else {
      setTokenFound(false);
    }
  } catch (err) {
    console.log("An error occurred while retrieving token. ", err);
  }
};

export const onMessageListener = (callback) => {
  if (!messaging) return;
  onMessage(messaging, (payload) => {
    callback(payload);
  });
};
